import { ENDPOINT_AI } from '../config'
import type { AiDebugSourceResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Inspect the composed embedding text for a WorkItem. The backend re-runs
 * the builder live (no stored copy), so this is exactly what the LLM would
 * see on the next embedding pass. WorkItem variant requires the caller to
 * hold ManageAiSettings AND ViewTasks (per-type permission stack).
 */
export async function getDebugWorkItem(
  workspaceSlug: string,
  workItemId: string,
): Promise<AiDebugSourceResponse> {
  const response = await AuthAxios.get<AiDebugSourceResponse>(
    `${ENDPOINT_AI(workspaceSlug)}/debug/source/workItem`,
    { params: { id: workItemId } },
  )
  return response.data
}

/**
 * Same as `getDebugWorkItem`, but for Documents. Document variant requires
 * ManageAiSettings only — documents have no per-page permission gate, the
 * workspace-member gate is enough for read access (mirrors
 * EmbeddingSearchService.cs).
 */
export async function getDebugDocument(
  workspaceSlug: string,
  documentId: string,
): Promise<AiDebugSourceResponse> {
  const response = await AuthAxios.get<AiDebugSourceResponse>(
    `${ENDPOINT_AI(workspaceSlug)}/debug/source/document`,
    { params: { id: documentId } },
  )
  return response.data
}
